export const textFitMixin = {
  data() {
    return {
      width: null
    }
  },
  mounted() {
    this.matchWidth()
    // Register the event listener for resize
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    // Unregister the event listener before destroying this Vue instance
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    matchWidth() {
      this.width = this.$refs['container'].clientWidth
    },
    onResize() {
      this.matchWidth()
    }
  },
  computed: {
    fontSize() {
      return this.width / 10 + 'px'
    }
  }
}
